import script from "./ProfileSpouseRemoveModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSpouseRemoveModal.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileSpouseRemoveModal.vue?vue&type=style&index=0&id=25cd5c0a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25cd5c0a"]])

export default __exports__